import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";

const ExtractedLineItemsModal = ({ open, onClose, record }) => {
  
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}

      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            fontFamily: "GilroyBold",
            pb: 1,
          }} 
          
        >
          Item Catalog Details
        </DialogTitle>

        <Button
          variant="contained"
          color="primary"
          
          sx={{ fontFamily: "gilroyBold", fontSize: "13px",m:2}}
          onClick={onClose}
        >
          Close
        </Button>
      </Box>

      <DialogContent>
        <Box sx={{ mt: 1, width: "100%", overflowX: "auto" }}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            }}
          >
            <Table stickyHeader sx={{ whiteSpace: "nowrap" }}>
              <TableHead>
                <TableRow>
                  {[
                    "Sr. No.",
                    "Part No",
                    "Description of Goods",
                    "HSN Code",
                    "Quantity.",
                    "Unit of Measure",
                    "IGST % ",
                    "SGST %",
                    "Unit Price",
                    "Total Price",
                  ].map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontWeight: 600,
                        fontFamily: "GilroySemiBold",
                        backgroundColor: "#e0e9ee",
                        fontSize: "14px",
                        borderBottom: "1px solid #e2e8f0",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {(record?.data || []).map((item, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["Sr. No."] ?? "-"}
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["Part No"] ?? "-"}
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["Description of Goods"] ?? "-"}
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["HSN Code"] ?? "-"}
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["Qty."] ?? "-"}
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["UOM"] ?? "-"}
                    </TableCell>

                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["igst"] || item.igst }
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["sgst"] ?? "-"}
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {item["Rate"].toLocaleString("en-IN",{style:"currency",currency:"INR"}) ?? "-"}
                    </TableCell>

                    <TableCell
                      sx={{
                        fontFamily: "GilroyMedium",
                        fontSize: "14px",
                        color: "#075b97",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item["_row_total"].toLocaleString("en-IN",{style:"currency",currency:"INR"}) ?? "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ExtractedLineItemsModal;
